import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AutorizacionService } from "../services/autorizacion.service";

@Injectable()
export class MyGuardService implements CanActivate {

loggedIn = false;

constructor(private AutorizacionService:AutorizacionService){
    this.AutorizacionService.isLogged()
      .subscribe((result)=> {
        if(result && result.uid){
          this.loggedIn=true;
        }else{
          this.loggedIn=false;
        }
      }, (error)=>{
        this.loggedIn=false;
      })
	}

canActivate(){
	return this.loggedIn;
}

}





// WEBPACK FOOTER //
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/services/myguard.service.ts